import { render, staticRenderFns } from "./proposition.vue?vue&type=template&id=0be27e8b&scoped=true"
import script from "./proposition.vue?vue&type=script&lang=ts"
export * from "./proposition.vue?vue&type=script&lang=ts"
import style0 from "./proposition.vue?vue&type=style&index=0&id=0be27e8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be27e8b",
  null
  
)

export default component.exports